import { makeStyles } from '@cv/theme';
import Slide, { SlideProps } from '@mui/material/Slide';
import { useTheme } from '@mui/material/styles';
import useViewportMatch from '@shared/hooks/useViewportMatch';
import { ReactNode } from 'react';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
  },
}));

const reverse = {
  left: 'right',
  right: 'left',
  up: 'down',
  down: 'up',
} as const;

type Props = {
  direction?: SlideProps['direction'];
  transitionProps?: Omit<SlideProps, 'direction' | 'in' | 'children'>;
  children?: ReactNode;
};
const PageSlide = ({ transitionProps, direction = 'left', children }: Props) => {
  const theme = useTheme();
  const effectEnabled = !useViewportMatch('md');
  const { classes } = useStyles();
  return (
    <Slide
      {...transitionProps}
      direction={theme.direction === 'rtl' ? reverse[direction] : direction}
      mountOnEnter={true}
      unmountOnExit={true}
      appear={effectEnabled}
      enter={effectEnabled}
      in={true}
    >
      <div className={classes.root}>{children}</div>
    </Slide>
  );
};

export default PageSlide;
